import type React from 'react';

// Shared by `Table`'s `selectedRowKey` and `Surface.Row`'s `selected`.
export const SELECTED_ROW_BACKGROUND =
    'var(--malachite-table-row-selected-background, rgba(0, 175, 102, 0.15))';
export const SELECTED_ROW_FOREGROUND =
    'var(--malachite-table-row-selected-foreground, rgb(2, 122, 66))';
export const SELECTED_ROW_ACCENT = 'var(--malachite-table-row-selected-accent, rgb(2, 122, 66))';

// A context channel, not a theme token: no palette value, not settable via `applyTheme`, and
// `getCurrentTheme()` will not report it.
export const SELECTED_TEXT_CONTEXT = {
    '--malachite-ctx-text-primary': SELECTED_ROW_FOREGROUND,
} as React.CSSProperties;

// The fallback carries it until `applyTheme` runs: until then the token is unset.
const TEXT_PRIMARY = 'var(--malachite-text-primary, rgb(10, 10, 10))';

// Both the channel and `color` inherit, so a Surface or Table nested in a selected row
// resets both at its root.
export const FOREGROUND_RESET = {
    '--malachite-ctx-text-primary': TEXT_PRIMARY,
    color: TEXT_PRIMARY,
} as React.CSSProperties;
